import { render, staticRenderFns } from "./UnresponsiveClientsSecondAttempt.vue?vue&type=template&id=5126ecd9&scoped=true&"
import script from "./UnresponsiveClientsSecondAttempt.vue?vue&type=script&lang=js&"
export * from "./UnresponsiveClientsSecondAttempt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5126ecd9",
  null
  
)

export default component.exports